import { PrivacyAndTerms } from "../../components";
import privacy from "./images/privacy.png";

const Privacy = () => {
  return (
    <PrivacyAndTerms
      params={{ src: privacy, title: "footer.item.privacy", content: "privacy.content" }}
    />
  );
};

export default Privacy;
